<template>
  <div class="login-container">
    <div class="login-form-container">
      <div class="title-container" />
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        auto-complete="off"
        size="medium"
      >
        <div class="name-container">
          <h3 class="name">
            睿终端营销服务平台
          </h3>
        </div>
        <el-form-item prop="userName">
          <el-input
            ref="userName"
            v-model="loginForm.userName"
            placeholder="请输入账号"
            type="text"
            tabindex="1"
            maxlength="32"
            prefix-icon="icon iconfont icon-username"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            ref="password"
            key="password"
            v-model="loginForm.password"
            placeholder="请输入密码"
            type="password"
            tabindex="2"
            maxlength="32"
            prefix-icon="icon iconfont icon-password"
            show-password
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-button
          :loading="loading"
          type="primary"
          class="login-btn"
          size="medium"
          @click.native.prevent="handleLogin"
        >
          登 录
        </el-button>
      </el-form>
      <!-- <div class="company">
        成都恒睿盛格营销策划有限公司
      </div> -->
    </div>
    <!-- 修改密码dialog -->
    <el-dialog
      v-if="updatePasswordVisible"
      :title="updatePasswordTitle"
      :visible.sync="updatePasswordVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      destroy-on-close
      append-to-body
      class="abow_dialog navbar-dialog h340_dialog"
      width="400px"
    >
      <el-form
        ref="updatePasswordForm"
        :model="updatePasswordForm"
        :rules="updatePasswordFormRules"
      >
        <span style="color:red">您使用的是初始密码，请修改您的密码</span>
        <el-form-item
          label="原密码"
          prop="oldPassword"
        >
          <el-input
            v-model="updatePasswordForm.oldPassword"
            clearable
            autofocus
            placeholder="请输入原密码"
          />
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="newPassword"
        >
          <el-input
            v-model="updatePasswordForm.newPassword"
            clearable
            placeholder="请输入新密码"
          />
        </el-form-item>
        <el-form-item
          label="密码确认"
          prop="confirmPassword"
        >
          <el-input
            v-model="updatePasswordForm.confirmPassword"
            clearable
            placeholder="请输入再输入一次新密码"
          />
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">
          关闭
        </el-button>
        <el-button
          type="primary"
          @click="handleUpdate"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updatePwdApi } from "@/api/user";

export default {
  name: 'Login',
  components: {},
  data () {
    const validateUserName = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error('请输入账号'))
      } else if (value.length < 4) {
        callback(new Error('账号不应少于4个字符'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码不应少于6个字符'))
      } else {
        callback()
      }
    }
    // 验证密码大小写加数字
    const validateNewPassword = (rule, value, callback) => {
      let includeNumber = false; let includeSmallLetter = false; let includeBigLetter = false
      if (/\d/.test(value)) includeNumber = true // 是否包含数字
      if (/[a-z]/.test(value)) includeSmallLetter = true // 是否包含字母【小写】
      if (/[A-Z]/.test(value)) includeBigLetter = true // 是否包含字母【大写】
      if (!includeNumber || !includeSmallLetter || !includeBigLetter) {
        callback(new Error('密码必须包含数字、大写字母、小写字母'))
      } else if (value.length < 6) {
        callback(new Error('密码不应少于6个字符'))
      } else {
        callback()
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error('请输入确认密码'))
      } else if (value !== this.updatePasswordForm.newPassword) {
        callback(new Error('两次密码不一致'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        userName: '',
        password: '',
      },
      loginRules: {
        userName: [
          { required: true, trigger: 'blur', validator: validateUserName }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ]
      },
      updatePasswordTitle: '修改密码',
      updatePasswordVisible: false,
      updatePasswordForm: {
        loginUserId: 0,
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      updatePasswordFormRules: {
        oldPassword: [
          {
            required: true,
            message: "请输入原密码",
            trigger: "blur"
          }
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur"
          },
          {
            trigger: "blur",
            validator: validateNewPassword
          }
        ],
        confirmPassword: [
          { required: true, trigger: 'blur', validator: validateConfirmPassword }
        ]
      },
      loading: false
    }
  },
  mounted () {
    if (this.loginForm.userName === '') {
      this.$refs.userName.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    }
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('user/loginStore', this.loginForm)
            .then(() => {
              this.$router.push({ path: '/' }).catch({})
              this.loading = false
            }).catch((error) => {
              // console.log(error)
              this.loading = false
              if (error) {
                let resultObj = JSON.parse(error)
                if (resultObj.message === 'initPassword') { // 初始密码
                  this.updatePasswordForm.loginUserId = resultObj.userKey
                  this.updatePasswordForm.oldPassword = ""
                  this.updatePasswordForm.newPassword = ""
                  this.updatePasswordForm.confirmPassword = ""
                  this.updatePasswordVisible = !this.updatePasswordVisible
                }
              }
            })
        } else {
          return false
        }
      })
    },
    // 关闭修改密码弹窗
    handleClose () {
      this.updatePasswordVisible = !this.updatePasswordVisible;
      this.$refs.updatePasswordForm.clearValidate();
    },
    // 修改密码
    handleUpdate () {
      this.$refs.updatePasswordForm.validate(valid => {
        if (valid) {
          let _this = this;
          let params = {
            id: _this.updatePasswordForm.loginUserId,
            oldPassword: _this.updatePasswordForm.oldPassword,
            passWord: _this.updatePasswordForm.newPassword,
            isUpdatePwd: 1,
            isLogin: 1
          }
          updatePwdApi(params).then(() => {
            _this.updatePasswordVisible = !_this.updatePasswordVisible;
            this.$message({
              message: '密码修改成功',
              type: 'success'
            })
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #283443;
  ::v-deep .el-input--suffix.el-input--medium .el-input__inner {
    padding-left: 30px !important;
  }
}

.login-form-container {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 440px;
  margin-left: -220px;
  margin-top: -225px;
  .title-container {
    margin: 0 auto;
    width: 286px;
    height: 84px;
    background-image: url(./img/new-login-logo.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .login-form {
    margin-top: 0px;
    padding: 0 40px;
    background: #fff;
    .name-container {
      color: #343c4c;
      text-align: center;
      .name {
        padding-top: 40px;
        font-weight: 400;
        font-size: 18px;
      }
    }
    .el-form-item {
      margin-bottom: 20px;
      .el-select {
        display: block;
      }
    }
    .el-input--medium {
      .el-input__inner,
      .el-input__icon {
        height: 40px;
        line-height: 40px;
      }
    }
    .el-input__prefix {
      left: 0;
      top: 2px;
      display: inline-block;
      z-index: 10;
      text-align: left;
      line-height: 42px;
      .iconfont {
        font-size: 32px;
        line-height: 42px;
      }
    }
    .el-input--prefix,
    .el-input--suffix {
      .el-input__inner {
        padding-left: 50px;
        border-radius: 2px;
      }
    }
  }
  .login-check {
    margin-bottom: 16px;
    text-align: right;
  }

  .login-btn {
    margin-bottom: 30px;
    height: 50px;
    width: 100%;
    font-size: 18px;
  }
}
.copy {
  margin-top: 12px;
  height: 44px;
  line-height: 44px;
  border: 1px dashed rgba(255, 255, 255, 0.5);
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  text-align: center;
}
.select-lang-popper {
  border-radius: 2px;
}
.select-lang-popper.el-popper[x-placement^='bottom'] ::v-deep .popper__arrow {
  display: none;
}
::v-deep .el-input--medium .el-input__inner {
  height: 42px;
  line-height: 42px;
}
::v-deep .el-input--medium .icon {
  font-size: 22px;
  line-height: 42px;
}
::v-deep .el-input--suffix.el-input--medium {
  .el-input__inner {
    padding-left: 30px;
  }
}
.company {
  margin-top: 10px;
  font-size: 12px;
  color: #fff;
  text-align: center;
}
</style>
